import React, { useContext, useEffect } from "react";
import { useToast, Button, HStack, Text } from "@chakra-ui/react";
import { UpdateContext } from "../context/UpdateContext";

const UpdateNotification = () => {
  const toast = useToast();
  const { updateAvailable, skipUpdate, applyUpdate } =
    useContext(UpdateContext);

  useEffect(() => {
    if (updateAvailable) {
      toast({
        position: "top",
        duration: null,
        isClosable: true,
        onCloseComplete: skipUpdate,
        render: () => (
          <HStack
            bg="blue.500"
            color="white"
            px={6}
            py={4}
            borderRadius="md"
            boxShadow="lg"
            justify="space-between"
            minW="300px"
            gap={6}
          >
            <Text fontWeight="medium">✨ New version available!</Text>
            <HStack gap={2}>
              <Button
                size="sm"
                bg="blue.600"
                _hover={{ bg: "blue.700" }}
                onClick={skipUpdate}
              >
                Later
              </Button>
              <Button
                size="sm"
                bg="white"
                color="blue.500"
                fontWeight="bold"
                _hover={{ bg: "gray.100" }}
                onClick={applyUpdate}
              >
                Update Now
              </Button>
            </HStack>
          </HStack>
        ),
      });
    }
  }, [updateAvailable, toast, skipUpdate, applyUpdate]);

  return null;
};

export default UpdateNotification;
